import React, { useEffect, useState } from "react";
import { getEmployeesWithoutLeave } from "../../api/employeeApi"; 
import { AllocateLeavesForEmployee, AllocateLeavesForAll } from "../../api/leavesApi"; 
import { useNavigate } from "react-router-dom"; 
import "../../css/CustomTable.css";

import { hasRight } from "../../utils/userRights";

export default function EmployeesWithoutLeave() {
  const [employees, setEmployees] = useState([]);
  const [leaves, setLeaves] = useState([]); // store leaves data
  const [year, setYear] = useState(new Date().getFullYear());
  const [user, setUser] = useState("");
  const [showLeaves, setShowLeaves] = useState(false); //toggle details

  const navigate = useNavigate();

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("username");
    if (loggedInUser) {
      setUser(loggedInUser);
    }
    fetchData();
  }, [year]);

  const fetchData = async () => {
    try {
      const data = await getEmployeesWithoutLeave(year);
      setEmployees(data || []);
    } catch (error) {
      console.error("Error fetching employees without leave", error);
      setEmployees([]);
    }
  };

  const handleAllocateLeave = async (empId, empCode) => {
    try {
      const data = await AllocateLeavesForEmployee(empId, year, user);
      alert(`Leave allocated for Employee Code: ${empCode}`);
      await fetchData();
    } catch (error) {
      console.error("Error allocating leave", error);
      alert("Failed to allocate leave");
    }
  };

  const handleAllocateAll = async () => {
    if (window.confirm("Are you sure you want to allocate leave for ALL employees?")) {
      try {
        const data = await AllocateLeavesForAll(year, user);
        alert(data.message || "Leave allocated for ALL Employees");
        await fetchData();
      } catch (error) {
        console.error("Error allocating all leaves", error);
        alert("Failed to allocate all leaves");
      }
    }
  };

//   const handleViewLeaves = async () => {
//     try {
//       const data = await getAllLeaves();
//       setLeaves(data || []);
//       setShowLeaves(true);
//     } catch (error) {
//       console.error("Error fetching leave details", error);
//       alert("Failed to load leave details");
//     }
//   };

  return (
    <div className="container-fluid p-1">
      {/* Heading */}
      <h4 className="allowance-heading">Add Leaves (Employees Without Leave)</h4>

      {/* Year Input + Buttons */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <label htmlFor="yearInput" className="fw-bold mb-0">Enter Year:</label>
          <input
            id="yearInput"
            type="number"
            className="form-control"
            style={{ width: "150px" }}
            value={year}
            onChange={(e) => setYear(e.target.value)}
            min="2000"
            max="2100"
          />
        </div>
        <div>
          {/* <button className="btn btn-success btn-sm me-2" onClick={handleAllocateAll}>
            Allocate All Leaves
          </button>  */}
          {hasRight("AllowanceMaster", "add") && (
            <button className="btn btn-success btn-sm me-2" onClick={handleAllocateAll}>
              Allocate All Leaves
            </button>
          )}
        
          <button className="btn btn-primary btn-sm" onClick={() => navigate("leave-list")}>
            View Leave Details
          </button>
          
        </div>
      </div>

      {/* Employees Table */}
      <div className="allowance-table-container mb-4">
        <table className="allowance-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Employee Code</th>
              <th>Full Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((emp, index) => (
                <tr key={emp.employeeID || index}>
                  <td>{index + 1}</td>
                  <td>{emp.employeeCode}</td>
                  <td>{emp.fullName}</td>
                  <td>
                    {/* <button
                      className="btn btn-sm btn-warning"
                      onClick={() => handleAllocateLeave(emp.employeeID, emp.employeeCode)}
                    >
                      Allocate Leave
                    </button> */}
                    {hasRight("AllowanceMaster", "add") && (
                      <button className="btn btn-sm btn-warning" onClick={() => handleAllocateLeave(emp.employeeID, emp.employeeCode)}>
                        Allocate Leave
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No employees found 🎉
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Leave Details Table */}
      {/* {showLeaves && (
        <div className="allowance-table-container">
          <h5 className="mb-2">Leave Details</h5>
          <table className="allowance-table">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Leave Code</th>
                <th>Leave Name</th>
                <th>Max Per Year</th>
              </tr>
            </thead>
            <tbody>
              {leaves.length > 0 ? (
                leaves.map((leave, index) => (
                  <tr key={leave.leaveCode || index}>
                    <td>{index + 1}</td>
                    <td>{leave.leaveCode}</td>
                    <td>{leave.leaveName}</td>
                    <td>{leave.maxPerYear}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No leave details found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )} */}


    </div>
  );
}








// import React, { useEffect, useState } from "react";
// import { getEmployeesWithoutLeave } from "../../api/employeeApi"; 
// import { AllocateLeavesForEmployee, AllocateLeavesForAll } from "../../api/leavesApi"; 
// import "../../css/CustomTable.css";

// export default function EmployeesWithoutLeave() {
//   const [employees, setEmployees] = useState([]);
//   const [year, setYear] = useState(new Date().getFullYear()); // default current year
//   const [user, setUser] = useState("");

//   useEffect(() => {
//     // Get logged-in user from session storage
//     const loggedInUser = sessionStorage.getItem("username");
//     if (loggedInUser) {
//       setUser(loggedInUser);
//     }

//     fetchData();
//   }, [year]);

//   const fetchData = async () => {
//     try {
//       const data = await getEmployeesWithoutLeave(year);
//       setEmployees(data || []);
//     } catch (error) {
//       console.error("Error fetching employees without leave", error);
//       setEmployees([]);
//     }
//   };

//   const handleAllocateLeave = async (empId, empCode) => {
//     try {
//       const data = await AllocateLeavesForEmployee(empId, year, user);
//       alert(`Leave allocated for Employee Code: ${empCode}`);
//       await fetchData();
//     } catch (error) {
//       console.error("Error allocating leave", error);
//       alert("Failed to allocate leave");
//     }
//   };

//   const handleAllocateAll = async () => {
//     if (window.confirm("Are you sure you want to allocate leave for ALL employees?")) {
//       try {
//         const data = await AllocateLeavesForAll(year, user);
//         alert(data.message || "Leave allocated for ALL Employees");
//         await fetchData();
//       } catch (error) {
//         console.error("Error allocating all leaves", error);
//         alert("Failed to allocate all leaves");
//       }
//     }
//   };

//   return (
//     <div className="container-fluid p-1">
//       {/* Heading */}
//       <h4 className="allowance-heading">Employees Without Leave</h4>

//       {/* Year Input */}

//       <div className="d-flex justify-content-between align-items-center mb-3">
//         {/* Left side - Label + Input */}
//         <div className="d-flex align-items-center" style={{ gap: "10px" }}>
//           <label htmlFor="yearInput" className="fw-bold mb-0">Enter Year:</label>
//           <input
//             id="yearInput"
//             type="number"
//             className="form-control"
//             style={{ width: "150px" }}
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//             min="2000"
//             max="2100"
//           />
//         </div>
      
//         {/* Right side - Buttons */}
//         <div>
//           <button className="btn btn-success btn-sm me-2" onClick={handleAllocateAll}>
//             Allocate All Leaves
//           </button>
//           <button className="btn btn-primary btn-sm" onClick={handleAllocate}>
//             View Leave Details
//           </button>
//         </div>
//       </div>
      
//       {/* Table */}
//       <div className="allowance-table-container">
//         <table className="allowance-table">
//           <thead>
//             <tr>
//               <th>Sr</th>
//               <th>Employee Code</th>
//               <th>Full Name</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.length > 0 ? (
//               employees.map((emp, index) => (
//                 <tr key={emp.employeeID || index}>
//                   <td>{index + 1}</td>
//                   <td>{emp.employeeCode}</td>
//                   <td>{emp.fullName}</td>
//                   <td>
//                     <button
//                       className="btn btn-sm btn-warning"
//                       onClick={() => handleAllocateLeave(emp.employeeID, emp.employeeCode)}
//                     >
//                       Allocate Leave
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center">
//                   No employees found 🎉
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }